import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import './NRDRUHSFooter.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { faYoutube, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import logoImage from './NRDRUHSLogo.png'; // Import the logo image

function NRDRUHSFooter() {
  const navigate = useNavigate();  // Initialize the navigate function inside the component
  
  // Check for user authentication from sessionStorage
  const isAuthenticated = sessionStorage.getItem('token');  // Assuming 'token' indicates logged-in state

  console.log('User is authenticated:', isAuthenticated);  // Logs the authentication status

  const handleContactUsClick = () => {
    console.log('Contact Us button clicked');  // Logs when the button is clicked
    
    if (isAuthenticated) {
      console.log('User is authenticated, navigating to /contactusauth');
      // If the user is logged in, navigate to the authenticated contact page
      navigate('/contactusauth');
    } else {
      console.log('User is not authenticated, navigating to /contactus');
      // If the user is not logged in, navigate to the regular contact page
      navigate('/contactus');
    }
  };

  return (
    <div className="footer-dark">
      <footer>
        <div className="container">
        <div className="row mt-5">
  {/* Column 1 */}
  <div className="col-md-4 item text">
    <img src={logoImage} alt="Logo" className="logo" />
  </div>

  {/* Column 2 */}
  <div className="col-md-4 item">
  <p style={{ paddingTop: 21 }}>
    An Official Publication of Rajasthan University for Health Sciences.<br />
    Subhash Nagar, Jhotwara Road, Jaipur – 302 016
    <br />
    <FaPhoneAlt style={{ marginRight: '8px' }} /> +91-9460654279
    <br />
    <FaEnvelope style={{ marginRight: '8px' }} /> nrdjournal@rhusraj.org
  </p>
</div>



  {/* Column 3 */}
  <div className="col-md-4 item">
    <h3>Links</h3>
    <ul>
      <li><a href="/sitemap">Site Map</a></li>
      <li><a href="/nrddownloads">Downloads​</a></li>
      <li><a href="/publications">Publications</a></li>
      <li><button onClick={handleContactUsClick}>Contact Us</button></li>
    </ul>
  </div>

  {/* Social icons (below the row, or inside another column if you want a 4th column) */}
  <div className="col item social mt-3">
    <a href="#"><FontAwesomeIcon icon={faYoutube} /></a>
    <a href="#"><FontAwesomeIcon icon={faTwitter} /></a>
    <a href="#"><FontAwesomeIcon icon={faInstagram} /></a>
  </div>
</div>

        </div>
      </footer>
    </div>
  );
}

export default NRDRUHSFooter;
